import StickyHeaderPresenter from "../components/sticky-header/presenter/sticky-header.js";

const catalogNavigationElement = document.querySelector(`.header-catalog`);
const footerElement = document.querySelector(`footer`);

if (catalogNavigationElement) {
  const stickyHeaderPresenter = new StickyHeaderPresenter({
    catalogNavigationElement,
    footerElement
  });
  stickyHeaderPresenter.init();
}
